module.exports = __webpack_public_path__ + "img/kakao-ch-final.47d7df86.png";